module.exports = __webpack_public_path__ + "img/大数据分析能力.a3f8230d.png";